module.exports = __webpack_public_path__ + "static/media/generalapi.e6f5d7ed.png";